import AttachmentsProvider from './root';
import AttachmentCard from './ui/AttachmentCard';
import ActionsSlot from './ui/ActionsSlot';
import { useAttachment } from './providers/attachment';

const AttachmentsManager = {
  Provider: AttachmentsProvider,
  Card: {
    Root: AttachmentCard,
    Actions: ActionsSlot,
    useAttachment,
  },
};

export default AttachmentsManager;
